import { render } from "./Topnav.vue?vue&type=template&id=6b9ae4b8"
import script from "./Topnav.vue?vue&type=script&lang=js"
export * from "./Topnav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__